// extracted by mini-css-extract-plugin
module.exports = {"editor":"TextTemplateDialog_editor__37ZAp","placeholder":"TextTemplateDialog_placeholder__3GLHY"};